'use client';

import { Gift, Sparkles } from 'lucide-react';

import { cn } from '@/components/ui/utils';

export function BalanceHero({
  balance,
  tier,
  walletValue,
  redemptionRate,
  currency,
  formatMoney,
}: {
  balance: number | null;
  tier?: string | null;
  walletValue?: number | null;
  redemptionRate?: { pointsPerUnit: number; valueAmount: number } | null;
  currency?: string | null;
  formatMoney: (amount: number, currency?: string | null) => string;
}) {
  return (
    <div className="cs-card relative overflow-hidden p-6">
      <div className="absolute -right-6 -top-6 size-24 rounded-full bg-[var(--cs-primary-light)]/30" />
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="cs-caption uppercase tracking-widest text-[var(--cs-text-muted)]">Your balance</p>
          <p className="cs-amount cs-amount-lg relative mt-1">{balance?.toLocaleString() ?? '0'}</p>
          <p className="cs-body-sm relative mt-1.5 text-[var(--cs-text-secondary)]">
            points
            {walletValue != null ? ` · worth about ${formatMoney(walletValue, currency)}` : ''}
          </p>
        </div>
        {tier ? (
          <span className="cs-badge cs-badge-success relative inline-flex shrink-0 items-center gap-1">
            <Sparkles className="size-3" aria-hidden="true" />
            {tier}
          </span>
        ) : null}
      </div>

      {redemptionRate && redemptionRate.pointsPerUnit > 0 ? (
        <p className="cs-body-sm relative mt-4 flex items-center gap-2 border-t border-[var(--cs-border)] pt-4 text-[var(--cs-text-secondary)]">
          <Gift className="size-4 shrink-0" aria-hidden="true" />
          {redemptionRate.pointsPerUnit} points = {formatMoney(redemptionRate.valueAmount, currency)} off your bill
        </p>
      ) : null}
    </div>
  );
}
